import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useAgentsEnabledFlag } from "src/pages/agents/hooks/use-agents-enabled-flag";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";

/**
 * The product gate is any of Data Agents, Ad Studio, or Lifecycle Studio.
 *
 * The Integrations card and its routes must agree, so both read this hook.
 */
export function useExternalContextEnabled(): boolean {
  const isAgentsEnabled = useAgentsEnabledFlag();
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();

  return isAgentsEnabled || isAdStudioEnabled || isLifecycleStudioEnabled;
}
